import React, { useState } from 'react';

import classNames from 'classnames';

import ModalDialog from 'components/ModalDialog/ModalDialog';
import { ReactComponent as SaveIcon } from 'assets/icons/save.svg';
import TextField from 'clean/components/common/TextField/TextField';

import styles from './SemesterGradeModal.module.scss';
import GradeInput from '../GradeInput/GradeInput';
import AttachmentElement from '../AttachmentElement/AttachmentElement';

interface Props {
  onClose: () => void;
}

const SemesterGradeModal: React.FC<Props> = ({ onClose }) => {
  const [value, setValue] = useState('');
  const ref = React.useRef(null);

  const users = [
    { id: 1, name: 'John Deer', grade: '+5', comment: 'This is a comment' },
    { id: 2, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 3, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 4, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 5, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 6, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 7, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 8, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 9, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 11, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 22, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 33, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 44, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 55, name: 'Sara Kingston', grade: '+2', comment: undefined },
    { id: 66, name: 'Sara Kingston', grade: '+2', comment: undefined },
  ];

  const handleKeyDown = event => {
    const keyMoves = {
      arrowdown: 2,
      enter: 2,
      arrowright: 1,
      escape: -1,
      arrowleft: -1,
      arrowup: -2,
    };
    const move = keyMoves[event.key.toLowerCase()];

    if (move !== undefined) {
      const inputs = [...ref.current.getElementsByTagName('input')];
      const index = inputs.indexOf(event.target);
      inputs[index + move]?.focus();
      event.preventDefault();
    }
  };

  return (
    <ModalDialog
      open={true}
      hasContentPadding={false}
      onClose={onClose}
      title={'Add grades'}
      actionsJustifyContent="center"
      actions={[
        {
          type: 'filled',
          colour: 'primary',
          label: 'Save grades',
          handler: () => null,
          startIcon: <SaveIcon />,
        },
      ]}
    >
      <div className={styles.container} ref={ref}>
        <div className={styles.columnLayout}>
          <div className={styles.column}>
            <div className={classNames(styles.columnTitle, 'text-label')}>Subject</div>
            <div className={styles.columnValue}>Mathematics</div>
          </div>
          <div className={styles.column}>
            <div className={classNames(styles.columnTitle, 'text-label')}>CLASS</div>
            <div className={styles.columnValue}>7B</div>
          </div>
          <div className={styles.column}>
            <div className={classNames(styles.columnTitle, 'text-label')}>PERIOD</div>
            <div className={styles.columnValue}>1st Semester</div>
          </div>
          <div className={styles.column}>
            <div className={classNames(styles.columnTitle, 'text-label')}>Teacher</div>
            <div className={styles.columnValue}>Alfred Heisenberg</div>
          </div>
        </div>

        <div className={styles.tableContainer}>
          <table>
            <thead>
              <tr>
                <th style={{ width: '30%' }}>Student</th>
                <th>Suggested</th>
                <th>Grade</th>
                <th style={{ width: '65%' }}>Comment</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => {
                return (
                  <tr key={u.id}>
                    <td className={styles.cellName}>{u.name}</td>
                    <td className={styles.cellSuggested}>+2 (2.39)</td>
                    <td className={styles.cellGrade}>
                      <GradeInput
                        newGrade={value}
                        setNewGrade={setValue}
                        inputOnly={true}
                        onKeyDown={handleKeyDown}
                      />
                    </td>
                    <td className={styles.cellComment}>
                      <TextField
                        placeholder="Type comment..."
                        className={styles.gradeInput}
                        onKeyDown={handleKeyDown}
                        value={value}
                        onChange={e => {
                          setValue(e.target.value);
                        }}
                      />
                    </td>
                    <td className={styles.cellAttachment}>
                      <AttachmentElement />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </ModalDialog>
  );
};

export default SemesterGradeModal;
